import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Conversation, Chat } from "../../Types/Conversation"

const getUnseenMessagesCount = (conversations: Array<Conversation>) => {
    return conversations.reduce((sum, conversation) => sum + Math.max(0, conversation.unseen_messages || 0), 0)
}

const initialState:  Chat = {activeConversationId: 0,conversations: [], hasUnseenMessages: false, unseenMessagesCount: 0, hasMoreConversations: false}

const ChatSlice = createSlice({
    name: "ChatListSlice",
    initialState: initialState,
    reducers: {
        setConversationList(state, action: PayloadAction<Array<Conversation>>) {
           let data = action.payload
           state.conversations = data
              state.unseenMessagesCount = getUnseenMessagesCount(data)
              state.hasUnseenMessages = state.unseenMessagesCount > 0
        },
        setActiveConversation(state, action: PayloadAction<number>) {
            let id = action.payload
            state.activeConversationId = id
         },
        setHasUnseenMessages(state, action: PayloadAction<boolean>) {
            state.hasUnseenMessages = action.payload
         },
        setHasMoreConversations(state, action: PayloadAction<boolean>) {
            state.hasMoreConversations = action.payload
         },
        setUnseenMessagesCount(state, action: PayloadAction<number>) {
            state.unseenMessagesCount = Math.max(0, action.payload)
            state.hasUnseenMessages = state.unseenMessagesCount > 0
         },
        incrementUnseenMessagesCount(state, action: PayloadAction<number | undefined>) {
            const incrementBy = action.payload ?? 1
            state.unseenMessagesCount = Math.max(0, state.unseenMessagesCount + incrementBy)
            state.hasUnseenMessages = state.unseenMessagesCount > 0
         },
        clearUnseenMessagesCount(state) {
            state.unseenMessagesCount = 0
            state.hasUnseenMessages = false
         }
    }
})

export const {
    setConversationList,
    setActiveConversation,
    setHasUnseenMessages,
    setHasMoreConversations,
    setUnseenMessagesCount,
    incrementUnseenMessagesCount,
    clearUnseenMessagesCount,
} = ChatSlice.actions
export default ChatSlice.reducer